(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dpet-featured-brands"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('dpet-brands')){
 customElements.define('dpet-brands',class extends HTMLElement{
  connectedCallback(){
   this.cleanup();this.events=new AbortController();const signal=this.events.signal;
   this.track=this.querySelector('.dpet-brands__track');this.controls=this.querySelector('.dpet-brands__controls');this.toggle=this.querySelector('.dpet-brands__toggle');
   if(!this.track||!this.controls||!this.toggle)return;
   this.motion=matchMedia('(prefers-reduced-motion:reduce)');this.stopped=this.dataset.autoplay!=='true'||this.motion.matches;this.interactingUntil=0;
   this.querySelectorAll('[data-direction]').forEach(button=>button.addEventListener('click',()=>this.move(Number(button.dataset.direction)),{signal}));
   this.toggle.addEventListener('click',()=>{this.stopped=!this.stopped;this.updateControls();},{signal});
   this.motion.addEventListener('change',()=>{this.stopped=this.motion.matches||this.dataset.autoplay!=='true';this.updateControls();},{signal});
   this.addEventListener('pointerdown',()=>{this.interactingUntil=Date.now()+7000;},{signal});
   this.addEventListener('keydown',event=>{
    this.interactingUntil=Date.now()+7000;
    if(event.target===this.track&&(event.key==='ArrowLeft'||event.key==='ArrowRight')){event.preventDefault();this.move(event.key==='ArrowLeft'?-1:1);}
   },{signal});
   this.resize=new ResizeObserver(()=>this.updateControls());this.resize.observe(this.track);
   this.visibility=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;},{threshold:.2});this.visibility.observe(this);
   this.updateControls();this.timer=setInterval(()=>{
    if(this.stopped||this.motion.matches||!this.visible||document.hidden||this.matches(':hover')||this.contains(document.activeElement)||Date.now()<this.interactingUntil)return;
    this.move(1);
   },4500);
  }
  updateControls(){
   this.controls.hidden=true;
   this.toggle.hidden=true;
  }
  move(direction){
   const max=this.track.scrollWidth-this.track.clientWidth;if(max<=2)return;
   const step=this.track.firstElementChild.getBoundingClientRect().width+parseFloat(getComputedStyle(this.track).columnGap||0);
   const current=this.track.scrollLeft;
   const next=direction>0?(current>=max-2?0:Math.min(max,current+step)):(current<=2?max:Math.max(0,current-step));
   this.track.scrollTo({left:next,behavior:this.motion.matches?'instant':'smooth'});
  }
  cleanup(){clearInterval(this.timer);this.events?.abort();this.resize?.disconnect();this.visibility?.disconnect();}
  disconnectedCallback(){this.cleanup();}
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dpet-gift-cards"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('dpet-gift-selector')){customElements.define('dpet-gift-selector',class extends HTMLElement{connectedCallback(){this.buttons=[...this.querySelectorAll('[data-amount]')];this.link=this.querySelector('.dpet-gift__cta');this.display=this.closest('.dpet-gift__shell')?.querySelector('[data-gift-display]');this.ctaAmount=this.querySelector('[data-gift-cta-amount]');this.onClick=e=>{const button=e.target.closest('[data-amount]');if(!button)return;this.buttons.forEach(item=>{const selected=item===button;item.classList.toggle('is-selected',selected);item.setAttribute('aria-pressed',String(selected))});if(this.display)this.display.textContent=button.dataset.amount;if(this.ctaAmount)this.ctaAmount.textContent=button.dataset.amount;if(this.link)this.link.href=button.dataset.url};this.addEventListener('click',this.onClick)}disconnectedCallback(){this.removeEventListener('click',this.onClick)}})}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dpet-shop-by-pet"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('dpet-pet-navigation')) {
  customElements.define('dpet-pet-navigation', class extends HTMLElement {
    connectedCallback() {
      this.observer?.disconnect();
      if (!('IntersectionObserver' in window)) return;
      this.observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-revealed');
          this.observer.unobserve(entry.target);
        });
      }, { threshold: .3 });
      this.querySelectorAll('.dpet-pets__item').forEach(item => this.observer.observe(item));
    }
    disconnectedCallback() { this.observer?.disconnect(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dpet-why-choose-us"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('dpet-benefits')){
  customElements.define('dpet-benefits',class extends HTMLElement{
    connectedCallback(){
      this.events?.abort();this.events=new AbortController();
      this.querySelectorAll('.dpet-benefit').forEach(card=>{
        const action=card.querySelector('.dpet-benefit__action');
        const label=action.dataset.expandLabel || action.textContent;action.dataset.expandLabel=label;
        const updateLabel=()=>{action.textContent=card.open?'Close details':label;};
        card.addEventListener('toggle',updateLabel,{signal:this.events.signal});updateLabel();
      });
      this.querySelectorAll('.dpet-rewards').forEach(calculator=>{
        const input=calculator.querySelector('input');
        const update=()=>{const spend=Number(input.value);const points=spend*3;calculator.querySelector('.dpet-rewards__spend').textContent='€'+spend;calculator.querySelector('.dpet-rewards__points').textContent=points+' points';calculator.querySelector('.dpet-rewards__credit').textContent='€'+(points/100).toFixed(2);};
        input.addEventListener('input',update,{signal:this.events.signal});update();
      });
    }
    disconnectedCallback(){this.events?.abort();}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-announcements"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dpet-announcement-ticker')) {
    customElements.define('dpet-announcement-ticker', class extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('button');
        if (!this.button || this.onToggle) return;
        this.onToggle = () => {
          const paused = this.toggleAttribute('data-paused');
          this.button.setAttribute('aria-pressed', String(paused));
          this.button.setAttribute('aria-label', paused ? 'Play announcements' : 'Pause announcements');
        };
        this.button.hidden = false;
        this.button.addEventListener('click', this.onToggle);
      }
      disconnectedCallback() {
        this.button?.removeEventListener('click', this.onToggle);
        this.onToggle = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('dpet-arrivals')) {
const { getArrivalsSeed, shuffleRecentArrivals } = (() => {
  const COOKIE = 'dpet_arrivals_seed_v1';
  const MAX_AGE = 14 * 24 * 60 * 60;
  const pendingRoots = new WeakMap();
  let seed;
  let seedPromise;
  let privacyPromise;

  const preferencesAllowed = () => {
    try { return window.Shopify?.customerPrivacy?.preferencesProcessingAllowed?.() === true; }
    catch (_) { return false; }
  };
  const newSeed = () => {
    const bytes = new Uint8Array(16);
    if (window.crypto?.getRandomValues) window.crypto.getRandomValues(bytes);
    else for (let i = 0; i < bytes.length; i++) bytes[i] = Math.floor(Math.random() * 256);
    return Array.from(bytes, value => value.toString(16).padStart(2, '0')).join('');
  };
  const readSeed = () => {
    if (!preferencesAllowed()) return null;
    try {
      const value = document.cookie.split(';').map(part => part.trim())
        .find(part => part.startsWith(`${COOKIE}=`))?.slice(COOKIE.length + 1);
      return value && /^[a-f0-9]{32}$/.test(value) ? value : null;
    } catch (_) { return null; }
  };
  const persistSeed = () => {
    if (!seed || !preferencesAllowed()) return;
    try { document.cookie = `${COOKIE}=${seed}; Max-Age=${MAX_AGE}; Path=/; SameSite=Lax; Secure`; }
    catch (_) { /* Blocked storage uses the same in-memory seed for this page. */ }
  };
  const ensurePrivacy = () => {
    if (typeof window.Shopify?.customerPrivacy?.preferencesProcessingAllowed === 'function') return Promise.resolve();
    if (privacyPromise) return privacyPromise;
    privacyPromise = new Promise(resolve => {
      let settled = false;
      let timeout;
      const done = () => {
        if (!settled) { settled = true; clearTimeout(timeout); resolve(); }
        // A late consent API may persist the already displayed order; never reshuffle.
        persistSeed();
      };
      timeout = setTimeout(done, 1000);
      if (typeof window.Shopify?.loadFeatures !== 'function') { done(); return; }
      try { window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], done); }
      catch (_) { done(); }
    });
    return privacyPromise;
  };
  document.addEventListener('visitorConsentCollected', () => {
    if (preferencesAllowed()) { persistSeed(); return; }
    // Expire our own preference cookie after consent is withdrawn; do not read it.
    if (typeof window.Shopify?.customerPrivacy?.preferencesProcessingAllowed === 'function') {
      try { document.cookie = `${COOKIE}=; Max-Age=0; Path=/; SameSite=Lax; Secure`; }
      catch (_) { /* Nothing to remove when browser storage is blocked. */ }
    }
  });
  const getArrivalsSeed = () => {
    if (!seedPromise) seedPromise = (async () => {
      await ensurePrivacy();
      seed = readSeed() || newSeed();
      persistSeed();
      return seed;
    })();
    return seedPromise;
  };
  const rank = value => {
    let hash = 2166136261;
    for (let i = 0; i < value.length; i++) hash = Math.imul(hash ^ value.charCodeAt(i), 16777619);
    hash = Math.imul(hash ^ (hash >>> 16), 0x85ebca6b);
    hash = Math.imul(hash ^ (hash >>> 13), 0xc2b2ae35);
    return (hash ^ (hash >>> 16)) >>> 0;
  };
  const shuffleRecentArrivals = root => {
    if (!root.hasAttribute('data-arrivals-shuffle')) return Promise.resolve({ changed: false });
    if (pendingRoots.has(root)) return pendingRoots.get(root);
    const pending = (async () => {
      const visitorSeed = await getArrivalsSeed();
      if (!root.isConnected) return { changed: false };
      const original = root.querySelector('slideshow-component.resource-list__carousel');
      if (!original) return { changed: false };
      const clone = original.cloneNode(true);
      const scroller = clone.querySelector(':scope > slideshow-container > slideshow-slides');
      if (!scroller) return { changed: false };
      const slides = Array.from(scroller.children).filter(node => node.localName === 'slideshow-slide');
      const now = Date.now();
      const cutoff = now - MAX_AGE * 1000;
      const requestedLimit = Number.parseInt(root.dataset.arrivalsLimit || '16', 10);
      const limit = Number.isFinite(requestedLimit) ? Math.max(1, Math.min(50, requestedLimit)) : 16;
      const seen = new Set();
      const eligible = [];
      for (const slide of slides) {
        const item = slide.querySelector('.resource-list__item[data-arrivals-created-at]');
        const id = item?.querySelector('product-card[data-product-id]')?.getAttribute('data-product-id');
        const createdAt = Number(item?.dataset.arrivalsCreatedAt) * 1000;
        if (!id || seen.has(id) || !Number.isFinite(createdAt) || createdAt < cutoff || createdAt > now) continue;
        seen.add(id);
        eligible.push({ slide, id, score: rank(`${visitorSeed}:${id}`) });
      }
      eligible.sort((a, b) => a.score - b.score || (a.id < b.id ? -1 : a.id > b.id ? 1 : 0));
      const selected = eligible.slice(0, limit);
      if (!selected.length) {
        original.remove();
        root.dataset.arrivalsShuffled = 'true';
        return { changed: true, count: 0 };
      }
      // Reorder detached clones only: moving connected quick-add elements can abort
      // their listeners. Preserve all native wrappers, forms, controls and IDs.
      for (const slide of slides) slide.remove();
      selected.forEach(({ slide }, index) => {
        slide.style.setProperty('--slideshow-timeline', `--slide-${index}`);
        slide.setAttribute('aria-hidden', index === 0 ? 'false' : 'true');
        scroller.append(slide);
      });
      clone.style.setProperty('--slideshow-timeline', selected.map((_, index) => `--slide-${index}`).join(', '));
      clone.setAttribute('initial-slide', '0');
      original.replaceWith(clone);
      root.dataset.arrivalsShuffled = 'true';
      return { changed: true, count: selected.length };
    })();
    pendingRoots.set(root, pending);
    pending.then(result => { if (!result.changed) pendingRoots.delete(root); }, () => pendingRoots.delete(root));
    return pending;
  };
  return { getArrivalsSeed, shuffleRecentArrivals };
})();

  customElements.define('dpet-arrivals', class extends HTMLElement {
    async connectedCallback() {
      this.disconnectedCallback();
      this.events = new AbortController();
      const { signal } = this.events;
      try { await shuffleRecentArrivals(this); }
      catch (error) { console.warn('Hot Arrivals: using the standard order.', error); }
      if (signal.aborted || !this.isConnected) return;
      this.scroller = this.querySelector('slideshow-component.resource-list__carousel > slideshow-container > slideshow-slides');
      if (!this.scroller) return;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.finePointer = matchMedia('(hover: hover) and (pointer: fine)');
      this.direction = 1;
      this.position = this.scroller.scrollLeft;
      this.pauseUntil = 0;
      this.visible = false;
      const pause = () => { this.pauseUntil = performance.now() + 7000; this.position = this.scroller.scrollLeft; };
      this.addEventListener('pointerdown', () => { this.dragging = true; pause(); }, { signal, passive: true });
      window.addEventListener('pointerup', () => { if (this.dragging) { this.dragging = false; pause(); } }, { signal, passive: true });
      window.addEventListener('pointercancel', () => { this.dragging = false; pause(); }, { signal, passive: true });
      this.addEventListener('wheel', pause, { signal, passive: true });
      this.addEventListener('keydown', pause, { signal });
      this.addEventListener('click', pause, { signal });
      this.observer = new IntersectionObserver(([entry]) => { this.visible = entry.isIntersecting; }, { threshold: .15 });
      this.observer.observe(this);
      const frame = now => {
        const dt = Math.min((now - (this.lastFrame || now)) / 1000, .04);
        this.lastFrame = now;
        const paused = this.motion.matches || !this.visible || document.hidden || this.dragging || now < this.pauseUntil || this.contains(document.activeElement) || (this.finePointer.matches && this.matches(':hover'));
        const max = this.scroller.scrollWidth - this.scroller.clientWidth;
        if (paused || max < 2) {
          this.position = this.scroller.scrollLeft;
        } else {
          this.position = Math.max(0, Math.min(max, this.position + this.direction * 32 * dt));
          this.scroller.scrollLeft = this.position;
          if (this.position >= max || this.position <= 0) { this.direction *= -1; this.pauseUntil = now + 900; }
        }
        this.frame = requestAnimationFrame(frame);
      };
      this.frame = requestAnimationFrame(frame);
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      clearInterval(this.timer);
      this.events?.abort();
      this.observer?.disconnect();
      this.lastFrame = 0;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
